import React from 'react';

const Toaster = React.lazy(() => import('./views/notifications/toaster/Toaster'));
const Tables = React.lazy(() => import('./views/base/tables/Tables'));

const Breadcrumbs = React.lazy(() => import('./views/base/breadcrumbs/Breadcrumbs'));
const Cards = React.lazy(() => import('./views/base/cards/Cards'));
const Carousels = React.lazy(() => import('./views/base/carousels/Carousels'));
const Collapses = React.lazy(() => import('./views/base/collapses/Collapses'));
const BasicForms = React.lazy(() => import('./views/base/forms/BasicForms'));

const Jumbotrons = React.lazy(() => import('./views/base/jumbotrons/Jumbotrons'));
const ListGroups = React.lazy(() => import('./views/base/list-groups/ListGroups'));
const Navbars = React.lazy(() => import('./views/base/navbars/Navbars'));
const Navs = React.lazy(() => import('./views/base/navs/Navs'));
const Paginations = React.lazy(() => import('./views/base/paginations/Pagnations'));
const Popovers = React.lazy(() => import('./views/base/popovers/Popovers'));
const ProgressBar = React.lazy(() => import('./views/base/progress-bar/ProgressBar'));
const Switches = React.lazy(() => import('./views/base/switches/Switches'));

const Tabs = React.lazy(() => import('./views/base/tabs/Tabs'));
const Tooltips = React.lazy(() => import('./views/base/tooltips/Tooltips'));
const BrandButtons = React.lazy(() => import('./views/buttons/brand-buttons/BrandButtons'));
const ButtonDropdowns = React.lazy(() => import('./views/buttons/button-dropdowns/ButtonDropdowns'));
const ButtonGroups = React.lazy(() => import('./views/buttons/button-groups/ButtonGroups'));
const Buttons = React.lazy(() => import('./views/buttons/buttons/Buttons'));
const Charts = React.lazy(() => import('./views/charts/Charts'));
const Dashboard = React.lazy(() => import('./views/dashboard/Dashboard'));
const CoreUIIcons = React.lazy(() => import('./views/icons/coreui-icons/CoreUIIcons'));
const Flags = React.lazy(() => import('./views/icons/flags/Flags'));
const Brands = React.lazy(() => import('./views/icons/brands/Brands'));
const Alerts = React.lazy(() => import('./views/notifications/alerts/Alerts'));
const Badges = React.lazy(() => import('./views/notifications/badges/Badges'));
const Modals = React.lazy(() => import('./views/notifications/modals/Modals'));
const Colors = React.lazy(() => import('./views/theme/colors/Colors'));
const Typography = React.lazy(() => import('./views/theme/typography/Typography'));
const Widgets = React.lazy(() => import('./views/widgets/Widgets'));
const Users = React.lazy(() => import('./views/users/Users'));
const User = React.lazy(() => import('./views/users/User'));

const routes = [
  { path: '/layout/', exact: true, name: 'Home' },
  { path: '/layout/dashboard', name: 'Dashboard', component: Dashboard },
  { path: '/layout/theme', name: 'Theme', component: Colors, exact: true },
  { path: '/layout/theme/colors', name: 'Colors', component: Colors },
  { path: '/layout/theme/typography', name: 'Typography', component: Typography },
  { path: '/layout/base', name: 'Base', component: Cards, exact: true },
  { path: '/layout/base/breadcrumbs', name: 'Breadcrumbs', component: Breadcrumbs },
  { path: '/layout/base/cards', name: 'Cards', component: Cards },
  { path: '/layout/base/carousels', name: 'Carousel', component: Carousels },
  { path: '/layout/base/collapses', name: 'Collapse', component: Collapses },
  { path: '/layout/base/forms', name: 'Forms', component: BasicForms },
  { path: '/layout/base/jumbotrons', name: 'Jumbotrons', component: Jumbotrons },
  { path: '/layout/base/list-groups', name: 'List Groups', component: ListGroups },
  { path: '/layout/base/navbars', name: 'Navbars', component: Navbars },
  { path: '/layout/base/navs', name: 'Navs', component: Navs },
  { path: '/layout/base/paginations', name: 'Paginations', component: Paginations },
  { path: '/layout/base/popovers', name: 'Popovers', component: Popovers },
  { path: '/layout/base/progress-bar', name: 'Progress Bar', component: ProgressBar },
  { path: '/layout/base/switches', name: 'Switches', component: Switches },
  { path: '/layout/base/tables', name: 'Tables', component: Tables },
  { path: '/layout/base/tabs', name: 'Tabs', component: Tabs },
  { path: '/layout/base/tooltips', name: 'Tooltips', component: Tooltips },
  { path: '/layout/buttons', name: 'Buttons', component: Buttons, exact: true },
  { path: '/layout/buttons/buttons', name: 'Buttons', component: Buttons },
  { path: '/layout/buttons/button-dropdowns', name: 'Dropdowns', component: ButtonDropdowns },
  { path: '/layout/buttons/button-groups', name: 'Button Groups', component: ButtonGroups },
  { path: '/layout/buttons/brand-buttons', name: 'Brand Buttons', component: BrandButtons },
  { path: '/layout/charts', name: 'Charts', component: Charts },
  { path: '/layout/icons', exact: true, name: 'Icons', component: CoreUIIcons },
  { path: '/layout/icons/coreui-icons', name: 'CoreUI Icons', component: CoreUIIcons },
  { path: '/layout/icons/flags', name: 'Flags', component: Flags },
  { path: '/layout/icons/brands', name: 'Brands', component: Brands },
  { path: '/layout/notifications', name: 'Notifications', component: Alerts, exact: true },
  { path: '/layout/notifications/alerts', name: 'Alerts', component: Alerts },
  { path: '/layout/notifications/badges', name: 'Badges', component: Badges },
  { path: '/layout/notifications/modals', name: 'Modals', component: Modals },
  { path: '/layout/notifications/toaster', name: 'Toaster', component: Toaster },
  { path: '/layout/widgets', name: 'Widgets', component: Widgets },
  { path: '/layout/users', exact: true,  name: 'Users', component: Users },
  { path: '/layout/users/:id', exact: true, name: 'User Details', component: User }
];

export default routes;
